import React, { useEffect, useState } from "react";
import { Col, Row, Button, Container, Modal } from "react-bootstrap";
import Layout from "../components/layout";
import ServerProps from "../lib/serverProps";

import offersController from "../lib/offers/offersController";
import PrivateRequestAccessController from "../lib/offers/privateAccessRequestControllers";
import serializable from "../lib/serializable";
import OfferCard from "../components/offers/OfferCard";
import LoginModal from "../components//auth/LoginModal";

const InvestPage = ({ state, data }) => {
  const login = () => {
    LoginModal.register(`/`);
  };

  // admin privet offer request list and request status
  const privateOffersByUserList = {};

  // manipulating privet offer request list and request status
  data.privateOffersByUser.forEach(
    (offer) => (privateOffersByUserList[offer?.OfferId] = offer?.status)
  );

  // appending "acceptedPrivateRequest" as a key with it's status (applied / accepted / rejected ) as the value
  // for all private requests offer objects
  const privateOffers =
    data?.privateOffers?.map((offer) => {
      if (privateOffersByUserList.hasOwnProperty(offer.id)) {
        offer["acceptedPrivateRequest"] = privateOffersByUserList[offer.id];
        return offer;
      }
      return offer;
    }) || [];

  return (
    <Layout
      title="Invest in Australian startups and scaleups"
      invertNav
      meta={{
        card: "summary_large_image",
        description:
          "Invest in Australian startups, scaleups and other growing businesses.",
      }}
      state={state}
      data={data}
    >
      <div className="bg4 header-content">
        <Container>
          <Row className="content">
            <Col className="hero-padding">
              <h1 className="hero-in-title">
                Venture investing
                <br />
                for everyone
              </h1>
              {/* <h3 className='home-in-sub-title'>Stride Equity is an equity crowdfunding platform, allowing retail and wholesale investors to invest in Australian startups and high-growth businesses.
              </h3> */}
            </Col>
          </Row>
        </Container>
      </div>
      <Container>
        <Row>
          <Col className="invest-banner-wrapper">
            {data.latestOffers.length == 0 &&
            data.EOIOffers.length == 0 &&
            data.privateOffers.length == 0 ? (
              <div className="text-center opp-comming my-5">
                <h2 className="home-title">
                  Investment opportunities are coming soon!
                </h2>

                {Object.keys(state.user).length === 0 && (
                  <>
                    <p className="home-title">
                      Join our growing investor community to get notified about
                      upcoming deals!
                    </p>
                    <Button onClick={login} className="btn btn-primary">
                      JOIN
                    </Button>
                  </>
                )}
              </div>
            ) : null}

            {data.latestOffers.length != 0 ? (
              <div className="section-invest">
                {" "}
                <h3 className="space-title title-2">Public Offers</h3>
                <div className="hr-border"></div>
                <OfferCard.Grid offers={data.latestOffers} user={state?.user} />
                {data.EOIOffers.length != 0 ? (
                  <div className="hr-border"></div>
                ) : null}
              </div>
            ) : null}

            {privateOffers.length != 0 ? (
              <div className="section-invest">
                <h3 className="space-title title-2">Private Offers</h3>
                <div className="hr-border"></div>
                <OfferCard.Grid
                  offers={data?.privateOffers}
                  user={state?.user}
                  interest={data?.interested}
                />
              </div>
            ) : null}

            {data.EOIOffers.length != 0 ? (
              <div className="section-invest">
                <h3 className="space-title title-2">Expressions of Interest</h3>
                <div className="hr-border"></div>
                <OfferCard.Grid offers={data.EOIOffers} user={state?.user} />
              </div>
            ) : null}
          </Col>
        </Row>
      </Container>
    </Layout>
  );
};

export async function getServerSideProps({ req, res }) {
  const state = await ServerProps.getState(req);
  const offers = await offersController.getPublished();
  const latestOffers = await offersController.getLatest();
  const EOIOffers = await offersController.getEOI();
  const privateOffers = await offersController.getPrivate();
  let interested = [];

  // private offers that user request has accepted by the admin
  let privateOffersByUser = [];

  if (state?.user?.id) {
    privateOffersByUser =
      await PrivateRequestAccessController.getApprovedOfferIds(state.user.id);
    interested = await offersController.getInterestedOffers(state?.user.id);
  }

  return {
    props: {
      state,
      data: {
        latestOffers: serializable(latestOffers),
        EOIOffers: serializable(EOIOffers),
        privateOffers: serializable(privateOffers),
        privateOffersByUser: serializable(privateOffersByUser),
        interested: serializable(
          interested?.map((interest) => interest?.offerId)
        ),
      },
    },
  };
}

export default InvestPage;
